import { Directive, input } from "@angular/core";

@Directive({
	selector: "[ssn]",
	standalone: false,
	host: {
		"(keydown)": "onKeyPress($event)",
		"(input)": "onKeyDown($event)",
	},
})
export class SSNDirective {
	ssn = input<boolean>();

	onKeyPress(event: KeyboardEvent) {
		if (event.key !== "Backspace" || !this.ssn()) {
			return;
		}

		const input = event.target as HTMLInputElement;

		const value = input.value;

		if (value.slice(-1) === "." || value.slice(-1) === "-") {
			input.value = value.slice(0, -1);
		}
	}

	onKeyDown(event: Event) {
		if (!this.ssn()) {
			return;
		}
		const input = event.target as HTMLInputElement;

		let value = input.value;
		const valueSplit = value.split("");
		const last = valueSplit[valueSplit.length - 1];

		if (last && !last.match(/[0-9]/)) {
			valueSplit.splice(valueSplit.length - 1, 1);
			value = valueSplit.join("");
		}

		if (value.length === 2 || value.length === 5 || value.length === 12) {
			value += ".";
		}
		if (value.length === 8) {
			value += "-";
		}

		if (value.length > 15) {
			value = value.substring(0, 15);
		}

		input.value = value;
	}
}
